var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fieldset"},[_c('h3',{staticClass:"h6 fieldset__title"},[_vm._v(_vm._s(_vm.header))]),_c('div',{staticClass:"fieldset__content row"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }